import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * QC (Quality Control) Module Service Stores
 * Aligned with Backend QC_IMPLEMENTATION_PLAN.md (FeathersJS 5.x + MSSQL)
 */
export const qcStores: ServiceStoreConfig[] = [
  // QC Configuration (per-company settings)
  {
    name: "qc-config",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
    },
  },

  // Checkpoint Definitions
  {
    name: "qc-checkpoints",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
    },
  },

  // Core Inspections
  {
    name: "qc-inspections",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
    },
  },

  // Checkpoint Results (linked to inspections)
  {
    name: "qc-checkpoint-results",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
    },
  },

  // Approval Records (audit trail)
  {
    name: "qc-approvals",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
    },
  },

  // Concrete Testing
  {
    name: "qc-concrete-tests",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
    },
  },

  // Cylinder Break Tests
  {
    name: "qc-cylinder-breaks",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
    },
  },

  // Defect Tracking
  {
    name: "qc-defects",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
    },
  },

  // Custom Bill of Materials
  {
    name: "qc-custom-bom",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
    },
  },

  // Drawing/Document References
  {
    name: "qc-drawings",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
    },
  },
];
